import { Component, Input, Output, EventEmitter } from '@angular/core';
import { environment } from 'environments/environment';
import { DetectPlatformService } from '../../services/detectPlatform.service';

@Component({
  selector: 'landing-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class LandingFooterComponent {
  @Input() isLoggedIn;
  @Output() onLinkClicked = new EventEmitter();
  androidLink = environment.androidAppLink;
  iOSLink = environment.iOSAppLink;

  constructor(public detectPlatformService: DetectPlatformService) {}
}
